module.exports = __webpack_public_path__ + "img/for_square_icon_speedometer.c05bfffe.png";